import campaigns_banner_arrow_left from 'shared/assets/images/campaigns/campaigns_banner_arrow_left.svg'
import campaigns_banner_arrow_right from 'shared/assets/images/campaigns/campaigns_banner_arrow_right.svg'
import { Icon, Typography } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import styles from './styles.module.scss'

export const CampaignBanner = () => {
  return (
    <div className={styles.wrap}>
      <img
        src={getCDNAssetURL(campaigns_banner_arrow_left)}
        alt='campaigns_banner_arrow_left'
        className={styles.leftArrow}
      />
      <div className={styles.items}>
        <div className={styles.item}>
          <div className={styles.counter}>
            <Typography ariaLabel={'counter'} variant={'body-xxs-medium'}>
              1
            </Typography>
          </div>
          <Typography ariaLabel={'counter'} variant={'body-sm-medium'}>
            Message
          </Typography>
        </div>
        <div className={styles.schedule}>
          <Icon icon={'clock'} color={'#1678C3'} />
          <Typography ariaLabel={'counter'} variant={'body-sm-medium'}>
            3 days later
          </Typography>
        </div>
        <div className={styles.item}>
          <div className={styles.counter}>
            <Typography ariaLabel={'counter'} variant={'body-xxs-medium'}>
              2
            </Typography>
          </div>
          <Typography ariaLabel={'counter'} variant={'body-sm-medium'}>
            Message
          </Typography>
        </div>
      </div>
      <img
        src={getCDNAssetURL(campaigns_banner_arrow_right)}
        alt='campaigns_banner_arrow_right'
        className={styles.rightArrow}
      />
    </div>
  )
}
